import {
  Icon,
  VStack,
  HStack,
  Text,
  Card,
  userAccountPhotoShouldUseInitials,
  resolveUserAccountPhotoToIconName,
} from "@repo/ui";
import type { Theme } from "@repo/tokens";

import styles from "./MultipleAccounts.module.scss";

export type UnifiedAccount = {
  unified_account_id: string;
  first_name: string;
  last_name: string;
  grade: number;
  user_account_photo: string | null;
};

function getInitials(firstName: string, lastName: string) {
  return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
}

function getFullName(firstName: string, lastName: string) {
  return `${firstName} ${lastName}`.trim();
}

export function getAccountCard(
  account: UnifiedAccount,
  classNames: typeof styles,
  theme: Theme,
  handlePress: () => void,
  colorIndex: number,
  isCardSelected: boolean,
) {
  const cardContainerClass = isCardSelected
    ? classNames.cardContainerSelected
    : classNames.cardContainer;

  const displayName = getFullName(account.first_name, account.last_name);

  if (!userAccountPhotoShouldUseInitials(account.user_account_photo)) {
    const avatarIcon = resolveUserAccountPhotoToIconName(
      account.user_account_photo,
    );
    return (
      <HStack className={classNames.cardWrapper}>
        <Card
          key={`account-card-${account.unified_account_id}`}
          className={cardContainerClass}
          onPress={handlePress}
        >
          <VStack
            alignItems="center"
            justifyContent="center"
            className={classNames.cardBodyColumn}
          >
            <VStack className={classNames.profileAvatorBox}>
              <Icon name={avatarIcon} size={50} />
            </VStack>
            <Text className={classNames.cardNameText}>{displayName}</Text>
            <Text className={classNames.cardGradeText}>
              Grade {account.grade}
            </Text>
          </VStack>
        </Card>
      </HStack>
    );
  }
  const cardAvatorDefaultBackgroundColors = [
    theme.colors.tertiary[95],
    theme.colors.success[95],
    theme.colors.secondary[80],
  ];
  const cardAvatorDefaultTextColors = [
    theme.colors.tertiary[30],
    theme.colors.success[30],
    theme.colors.secondary[20],
  ];
  const initials = getInitials(account.first_name, account.last_name);
  const bgColor = cardAvatorDefaultBackgroundColors[colorIndex];
  const textColor = cardAvatorDefaultTextColors[colorIndex];
  return (
    <HStack className={classNames.cardWrapper}>
      <Card
        key={`account-card-${account.unified_account_id}`}
        className={cardContainerClass}
        onPress={handlePress}
      >
        <VStack
          justify="center"
          alignItems="center"
          className={classNames.cardBodyColumn}
        >
          <VStack
            className={classNames.avatorBox}
            style={{ backgroundColor: bgColor }}
          >
            <Text
              className={classNames.cardAvatorText}
              style={{ color: textColor }}
            >
              {initials}
            </Text>
          </VStack>
          <Text className={classNames.cardNameText}>{displayName}</Text>
          <Text className={classNames.cardGradeText}>
            Grade {account.grade}
          </Text>
        </VStack>
      </Card>
    </HStack>
  );
}
